export default __webpack_public_path__ + "static/img_vision_fitco-d06915dcd6fcbb1058bbd35fad964c08.png";